export default "__VITE_ASSET__BCzNB7Rw__"